// hooks/useAside.js
import { useDispatch } from 'react-redux';
import { setRootAside } from '../state/component/AsideSlice';
import { ComponentKey } from '@components/layouts/Aside';

interface props {
  component: ComponentKey;
  data?: any;
  title?: string;
}

export function useAside() {
  const dispatch = useDispatch();

  const openAside = ({ component, data, title }: props) => {
    dispatch(
      setRootAside({
        component,
        data,
        title,
      })
    );
  };

  return { openAside };
}
